import { getParamValueFromUrl } from 'root/utils/URLParams/URLParams';

export default function isAboveTheFold(el: HTMLElement) {
    const topElRect = el.getBoundingClientRect().top;
    const scrollY = window.scrollY;
    const absoluteTop = topElRect + scrollY;
    debug(el, topElRect, scrollY, absoluteTop);
    return absoluteTop < window.innerHeight;
}

function debug(el: HTMLElement, topElRect: number, scrollY: number, absoluteTop: number) {
    if (getParamValueFromUrl('debug_atf') === 'true') {
        console.log({ el });
        console.table({
            topElRect,
            scrollY,
            absoluteTop: `topElRect + scrollY = ${absoluteTop}`,
            atfHeight: window.innerHeight,
            total: `${absoluteTop} < ${window.innerHeight}`,
        });
    }
}
